module.exports = __webpack_public_path__ + "img/title_2.d610fc62.png";